import { TabsContainer } from './styled';
export function PageTabs(props) {
    const { children } = props;
    return <TabsContainer>{children}</TabsContainer>;
}
